// extracted by mini-css-extract-plugin
export default {"addToCartControl":"T0-z","giftCard":"U0-z","btnContainer":"V0-z","cartButton":"W0-z","disabled":"X0-z"};